import axios from "axios";
import { API } from "./api";

// Background export jobs: tiny shared store polled while anything is in flight.
let jobs = [];
let timer = null;
const subs = new Set();
const autoDownload = new Set();
const ACTIVE = ["queued", "processing", "validating"];

const emit = () => subs.forEach((fn) => fn(jobs));

export const exportFileUrl = (id) => `${API}/exports/${id}/file`;

export const downloadExport = (id) => {
  const a = document.createElement("a");
  a.href = exportFileUrl(id);
  a.download = "";
  document.body.appendChild(a);
  a.click();
  a.remove();
};

const schedule = () => {
  if (!timer) timer = setTimeout(() => { timer = null; refreshExports(); }, 2000);
};

export async function refreshExports() {
  try {
    const { data } = await axios.get(`${API}/exports`);
    jobs = data;
    emit();
    for (const j of data) {
      if (j.status === "completed" && autoDownload.has(j.id)) {
        autoDownload.delete(j.id);
        downloadExport(j.id);
      }
      if (j.status === "failed") autoDownload.delete(j.id);
    }
    if (data.some((j) => ACTIVE.includes(j.status))) schedule();
  } catch {
    schedule();
  }
}

export async function startExport(bookId, fmt, args = {}) {
  const { data } = await axios.post(`${API}/exports`, { book_id: bookId, fmt, ...args });
  autoDownload.add(data.id);
  await refreshExports();
  return data;
}

export const subscribeExports = (fn) => {
  subs.add(fn);
  fn(jobs);
  return () => subs.delete(fn);
};

export const isActive = (j) => ACTIVE.includes(j.status);
